"use client";

import FeatureApplicationList from "./FeatureApplicationList";

export default function SuperUserApplicationList() {
  return (
    <FeatureApplicationList
      titleKey="titles.all_applications_superuser"
      descriptionKey="descriptions.all_applications_superuser"
    />
  );
}
